import { InjectionToken } from '@angular/core';
import { AssetLocation } from '../../models/asset-location/asset-location.model';

export const ASSET_LOCATION = new InjectionToken<AssetLocation>(
    'assetLocation',
);
